<script lang="ts">
    import { blur } from 'svelte/transition';

    import JobOneRow from '../Jobs/JobOneRow.svelte';
    import { Job } from '../Jobs/Job.js';
    import { JobsOnMap } from '../Jobs/JobsOnMap';
    import { _ } from 'svelte-i18n';
    import { clientSettings } from '../../../stores/api';

    export let componentProps: { jobs: Job[]; title: string };

    let expandedIndex = -1;
</script>

<div style="display: flex; flex-direction: column; row-gap: 20px; height: 90%;">
    <div style="font-size: 16px;">
        <span style="text-transform: capitalize">{$_(componentProps.title)}</span>
    </div>
    <div class="job-list" style="overflow: auto;">
        {#each componentProps.jobs as job, index (job.id)}
            <div in:blur|global>
                <JobOneRow
                    job={job.getData()}
                    {index}
                    bind:expandedIndex
                    showHeader={false}
                    enableMap={false}
                    enableCheckbox={false}
                    jobsOnMap={null}
                    bind:simpleView={$clientSettings.display.simple_view}
                    on:setcoordinates={() => {}}
                />
            </div>
        {/each}
    </div>
</div>
